import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";

export default function AttendanceSummaryCard() {
  const [filter, setFilter] = useState("Today");

  // 🔥 Dynamic Date Logic
  const getDateLabel = () => {
    const today = new Date();

    if (filter === "Today") {
      return today.toLocaleDateString("en-US", {
        day: "numeric",
        month: "short",
        
      });
    }

    if (filter === "Weekly") {
      const first = today.getDate() - today.getDay();
      const last = first + 6;

      const start = new Date(today.setDate(first));
      const end = new Date(today.setDate(last));

      return `${start.getDate()} ${start.toLocaleString("default", {
        month: "short",
      })} - ${end.getDate()} ${end.toLocaleString("default", {
        month: "short",
      })}`;
    }

    if (filter === "Monthly") {
      return today.toLocaleString("default", {
        month: "long",
       
      });
    }

  
  };

  return (
    <Card className="summary-card h-100">
      <Card.Body>
        {/* HEADER */}
        <div className="summary-header">
          <h5>Attendance Summary</h5>

          <Dropdown>
            <Dropdown.Toggle className="summary-dropdown">
              <FiCalendar /> {filter}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {["Today", "Weekly", "Monthly", "Yearly"].map((item) => (
                <Dropdown.Item key={item} onClick={() => setFilter(item)}>
                  {item}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        {/* DATE */}
        <div className="date-text">{getDateLabel()}</div>

        {/* LABEL */}
        <p className="label">Avg Working Hours</p>

        {/* PROGRESS */}
        <div className="progress custom-progress">
          <div className="progress-bar fill"></div>
        </div>

        {/* STATUS */}
        <div className="status-row">
          <span className="badge-custom">↓ 3.2%</span>
          <span className="compare-text">Compared to yesterday</span>
        </div>

        {/* STATS */}
        <div className="summary-stats">
          <div className="mini-card">
            <h4>2,458</h4>
            <p>Check-in Count</p>
          </div>

          <div className="mini-card">
            <h4>2,201</h4>
            <p>Check-out Count</p>
          </div>

          <div className="mini-card">
            <h4>9:12 AM</h4>
            <p>Check-in Time</p>
          </div>
        </div>
      </Card.Body>

      {/* INTERNAL CSS */}
      <style>{`
/* CARD */
.summary-card {
  border-radius: 5px;
  border: 2px solid #e5e7eb;
  padding: 5px;
}

/* HEADER */
.summary-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.summary-header h5 {
  font-size: 17px;
  font-weight: 600;
 
}


.dropdown-toggle::after {
  display: none !important;
}
/* DROPDOWN */
.summary-dropdown {
  background-color: #fff !important;
  color: #000 !important;
  border: 1px solid #e5e7eb !important;
  box-shadow: none !important;
}

.summary-dropdown svg {
  margin-right: 6px;
}

/* DATE */
.date-text {
  font-size: 12px;
  color: #6b7280;
  margin-top: 5px;
}

/* LABEL */
.label {
  margin-top: 18px;
  font-size: 14px;
  color: #374151;
}

/* PROGRESS */
.custom-progress {
  height: 10px;
  border-radius: 20px;
  background: #e5e7eb;
  margin-top: 8px;
}

.fill {
  width: 75%;
  background: #111;
  border-radius: 20px;
}

/* STATUS */
.status-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

.badge-custom {
  background: #ef4444;
  color: #fff;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 6px;
}

.compare-text {
  font-size: 13px;
  color: #6b7280;
}

/* STATS */
.summary-stats {
  display: flex;
  gap: 15px;
  margin-top: 20px;
}

.mini-card {
  flex: 1;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  text-align: center;
  padding: 18px 10px;
}

.mini-card h4 {
  margin: 0;
  font-weight: 600;
  color: #111827;
}

.mini-card p {
  margin: 5px 0 0;
  font-size: 13px;
  color: #6b7280;
}

/* MOBILE */
@media (max-width: 768px) {

  .summary-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .summary-dropdown {
    width: 100%;
    text-align: left;
  }

  .summary-stats {
    flex-direction: column;
  }

  .mini-card {
    padding: 15px;
  }

  .label {
    font-size: 13px;
  }

  .compare-text {
    font-size: 12px;
  }
}
      `}</style>
    </Card>
  );
}
